export default __webpack_public_path__ + "static/media/culture.f5104e49.svg";